import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Row, Col } from 'antd';
import { Modal } from 'antd-mobile';
import { withTranslation } from 'react-i18next';
import Format from '../../utils/format';
import * as SignalR from '@aspnet/signalr';

const confirmAlert = Modal.alert;
const REACT_APP_SIGNALR_URL = `${process.env.REACT_APP_STAYMENU_API_URL}/stayMenuHub`;

@inject(
  'templateStore',
  'CmsLanguageStore',
  'webSettingStore',
  'CmsMenuStore',
  'CmsClimateStore'
)
@observer
class Home extends Component {
  constructor(props) {
    super(props)
    this.state = {
    }
  }

  componentDidMount() {
    this.props.templateStore.getActive();
    this.props.CmsMenuStore.getActives();

    let connection = new SignalR.HubConnectionBuilder().withUrl(REACT_APP_SIGNALR_URL).build();
    connection.start().catch(function (err) { return console.error(err.toString()); });
    connection.on(`SignalR_SyncData`, () => { window.location.reload(true); });
  }

  componentWillUnmount() {
  }

  // ON CLICK

  menuSoonClick = () => {
    const { activeTemplate } = this.props.templateStore;
    const { data: webSetting } = this.props.webSettingStore;
    confirmAlert('',
      <div
        style={{
          fontFamily: activeTemplate.templateSetting.text.fontFamily,
          color: activeTemplate.templateSetting.text.color,
          fontSize: activeTemplate.templateSetting.text.fontSize,
          lineHeight: `${activeTemplate.templateSetting.text.fontSize + 6}px`,
          textAlign: 'center'
        }}
      >
        <span>Available Soon</span>
      </div>,
      [
        {
          text: webSetting.okText
        }
      ]);
  }

  menuClick = (taskID, menuType, isSoon, redirectUrl) => {
    const {
      activeLanguages
    } = this.props.CmsLanguageStore;

    const lang = window.localStorage.getItem('lang') || 'en';
    let languageId = 1;
    if (lang && activeLanguages.length > 0) {
      const language = activeLanguages.find(fi => fi.code === lang);
      if (language) {
        languageId = activeLanguages.find(fi => fi.code === lang).id;
      }
    }

    if (isSoon) {
      this.menuSoonClick();
    } else {
      switch (menuType) {
        case 'AMENITY':
          this.props.history.push(`amenity`);
          break;

        case 'HK_SERVICE':
        case 'CONCIERGE':
        case 'DEFECT_REPORT':
        case 'DND':
        case 'FRONT_OFFICE':
        case 'LATE_CHECKOUT':
          this.props.history.push(`single-list/${taskID}/language/${languageId}`);
          break;

        case 'BOOKING_FACILITY':
          this.props.history.push(`booking`);
          break;

        case 'IN_ROOM_DINING':
          this.props.history.push(`fnb`);
          break;

        case 'IN_ROOM_DINING_URL':
          if (redirectUrl) {
            window.open(redirectUrl, '_blank');
          } else {
            console.warn('Redirect URL is not configured for this menu');
          }
          break;

        case 'LAUNDRY':
          this.props.history.push(`laundry`);
          break;

        case 'PRINT_FILE':
          this.props.history.push(`print-file`);
          break;

        case 'RCU_CONTROL':
          this.props.history.push(`rcu-control`);
          break;

        case 'SHOPPING':
          this.props.history.push(`shopping`);
          break;

        case 'SPA':
          this.props.history.push(`spa`);
          break;

        case 'TRANSPORTATION':
          this.props.history.push(`transportation`);
          break;

        case 'TV_CHANNEL':
          this.props.history.push(`tv-channel`);
          break;

        case 'WAKE_UP_CALL':
          this.props.history.push(`wakeup-call`);
          break;

        default:
          break;
      }
    }
  }

  // ON RENDER

  getCheckinTimeOnRender = () => {
    let checkinTime = localStorage.getItem('checkinTime');

    if (checkinTime) {
      if (checkinTime !== 'null') {
        return checkinTime.replace(/^"(.*)"$/, '$1');
      }
    }

    return '-';
  }

  getCheckoutTimeOnRender = () => {
    let checkoutTime = localStorage.getItem('checkoutTime');

    if (checkoutTime) {
      if (checkoutTime !== 'null') {
        return checkoutTime.replace(/^"(.*)"$/, '$1');
      }
    }

    return '-';
  }

  render() {
    const { activeTemplate } = this.props.templateStore;
    const { data: webSettting } = this.props.webSettingStore;
    const showHeaderFooter = localStorage.getItem('showHeaderFooter');
    const checkinTime = this.getCheckinTimeOnRender();
    const checkoutTime = this.getCheckoutTimeOnRender();
    const lang = window.localStorage.getItem('lang') || 'en';
    const todayLang = Format.DateTimeDayLocale(new Date());
    const roomNo = JSON.parse(localStorage.getItem('roomNo'));
    const { defaultLang, main, description, temp, cityName, icon } = this.props.CmsClimateStore;
    const { data: activeMenus } = this.props.CmsMenuStore;
    const { activeLanguages } = this.props.CmsLanguageStore;

    let languageId = 1;
    if (lang && activeLanguages.length > 0) {
      const language = activeLanguages.find(fi => fi.code === lang);
      if (language) {
        languageId = activeLanguages.find(fi => fi.code === lang).id;
      }
    }

    return (
      <>
        {
          activeTemplate
            ?
            <>
              {/* Header & Menu */}
              {
                webSettting
                  ?
                  <>
                    <Row className={'stm-margin-top-50 stm-width-100-percent'}>
                      <Col
                        span={24}
                        className='stm-width-100-percent stm-height-auto stm-padding-20 stm-background-size-cover'
                        style={{
                          background: webSettting.homeImageUrl ? `url(${webSettting.homeImageUrl})` : 'black'
                        }}
                      >
                        <Row>
                          <Col span={24} className='stm-margin-bottom-20 stm-margin-top-8'>
                            <Row>
                              <Col
                                span={12}
                                className=''
                                style={{
                                  fontFamily: activeTemplate.templateSetting.homeHeader.fontFamily,
                                  color: activeTemplate.templateSetting.homeHeader.color,
                                  fontSize: activeTemplate.templateSetting.homeHeader.fontSize,
                                  lineHeight: `${activeTemplate.templateSetting.homeHeader.fontSize + 2}px`
                                }}
                              >
                                <span>{webSettting.roomText} {roomNo}</span>
                              </Col>
                              <Col
                                span={12}
                                className='stm-text-align-right'
                                style={{
                                  fontFamily: activeTemplate.templateSetting.homeHeader.fontFamily,
                                  color: activeTemplate.templateSetting.homeHeader.color,
                                  fontSize: activeTemplate.templateSetting.homeHeader.fontSize,
                                  lineHeight: `${activeTemplate.templateSetting.homeHeader.fontSize + 2}px`
                                }}
                              >
                                <>
                                  {
                                    icon
                                      ?
                                      <>
                                        <img
                                          src={icon}
                                          style={{
                                            height: 30,
                                            marginRight: -10,
                                            marginTop: -5
                                          }}
                                          alt='weather-icon' />
                                        <span className='stm-padding-left-8'>{cityName}</span>
                                      </>
                                      :
                                      null
                                  }
                                </>
                              </Col>
                            </Row>
                          </Col>
                          <Col span={24} className='stm-font-size-14 stm-line-height-16 stm-margin-bottom-6'>
                            <Row
                              style={{
                                fontFamily: activeTemplate.templateSetting.homeInfo.fontFamily,
                                color: activeTemplate.templateSetting.homeInfo.color,
                                fontSize: activeTemplate.templateSetting.homeInfo.fontSize,
                                lineHeight: `${activeTemplate.templateSetting.homeInfo.fontSize + 2}px`
                              }}
                            >
                              <Col span={12} className=''>
                                <span>C/In: {checkinTime}</span>
                              </Col>
                              <Col span={12} className='stm-text-align-right'>
                                <>
                                  {
                                    temp
                                      ?
                                      defaultLang
                                        ?
                                        <span>{main}, {temp}&deg;C</span>
                                        :
                                        <span>{description}, {temp}&deg;C</span>
                                      :
                                      null
                                  }
                                </>
                              </Col>
                            </Row>
                          </Col>
                          <Col span={24} className='stm-font-size-14 stm-line-height-16'>
                            <Row
                              style={{
                                fontFamily: activeTemplate.templateSetting.homeInfo.fontFamily,
                                color: activeTemplate.templateSetting.homeInfo.color,
                                fontSize: activeTemplate.templateSetting.homeInfo.fontSize,
                                lineHeight: `${activeTemplate.templateSetting.homeInfo.fontSize + 2}px`
                              }}
                            >
                              <Col span={12} className=''>
                                <span>C/Out: {checkoutTime}</span>
                              </Col>
                              <Col span={12} className='stm-text-align-right'>
                                <span>{temp ? todayLang : null}</span>
                              </Col>
                            </Row>
                          </Col>
                          <Col
                            span={24}
                            className=''
                            style={{
                              marginTop: activeTemplate.templateSetting.menu.marginTop,
                              marginBottom: activeTemplate.templateSetting.menu.marginBottom
                            }}
                          >
                            {/* Menu List */}
                            <Row>
                              {
                                activeMenus.slice(0, (activeMenus.length - (activeMenus.length % activeTemplate.templateSetting.menu.column))).map((menu) => {
                                  return (
                                    <Col key={menu.id} span={24 / activeTemplate.templateSetting.menu.column} className='stm-padding-2'>
                                      <Row>
                                        <Col
                                          span={24}
                                          className='stm-background-white-two stm-text-align-center stm-border-radius-4 stm-position-relative stm-padding-top-8 stm-padding-bottom-8'
                                          onClick={() => this.menuClick(menu.taskID, menu.menuType, menu.isSoon, menu.redirectUrl)}
                                        >
                                          {
                                            menu.isSoon
                                              ?
                                              <div className='stm-menu-soon'>{webSettting.soonText}</div>
                                              :
                                              null
                                          }
                                          <div className=''>
                                            <img src={menu.imageUrl} alt='iconUrl' className='stm-height-40 stm-width-auto' />
                                          </div>
                                          <div
                                            className='stm-display-flex stm-align-items-center stm-justify-content-center stm-height-40 stm-padding-top-4'
                                            style={{
                                              fontFamily: activeTemplate.templateSetting.menu.fontFamily,
                                              color: activeTemplate.templateSetting.menu.color,
                                              fontSize: activeTemplate.templateSetting.menu.fontSize,
                                              lineHeight: `${activeTemplate.templateSetting.menu.fontSize + 2}px`
                                            }}
                                          >
                                            <span>{menu.taskLanguages.find(fi => fi.langID === languageId).taskLangName}</span>
                                          </div>
                                        </Col>
                                      </Row>
                                    </Col>
                                  )
                                })
                              }
                            </Row>

                            {/* Remaining Menu */}
                            <>
                              {
                                activeMenus.length % activeTemplate.templateSetting.menu.column > 0
                                  ?
                                  <>
                                    <Row>
                                      {/* Blank */}
                                      <>
                                        {/* Menu Rows = 4 */}
                                        <>
                                          {
                                            activeTemplate.templateSetting.menu.column === 4
                                              ?
                                              <>
                                                {
                                                  activeMenus.length % activeTemplate.templateSetting.menu.column === 1
                                                    ?
                                                    <Col span={9} />
                                                    :
                                                    (
                                                      activeMenus.length % activeTemplate.templateSetting.menu.column === 2
                                                        ?
                                                        <Col span={6} />
                                                        :
                                                        (
                                                          activeMenus.length % activeTemplate.templateSetting.menu.column === 3
                                                            ?
                                                            <Col span={3} />
                                                            :
                                                            null
                                                        )
                                                    )
                                                }
                                              </>
                                              :
                                              null
                                          }
                                        </>

                                        {/* Menu Rows = 3 */}
                                        <>
                                          {
                                            activeTemplate.templateSetting.menu.column === 3
                                              ?
                                              <>
                                                {
                                                  activeMenus.length % activeTemplate.templateSetting.menu.column === 1
                                                    ?
                                                    <Col span={8} />
                                                    :
                                                    (
                                                      activeMenus.length % activeTemplate.templateSetting.menu.column === 2
                                                        ?
                                                        <Col span={4} />
                                                        :
                                                        null
                                                    )
                                                }
                                              </>
                                              :
                                              null
                                          }
                                        </>

                                        {/* Menu Rows = 2 */}
                                        <>
                                          {
                                            activeTemplate.templateSetting.menu.column === 2
                                              ?
                                              <>
                                                <Col span={6} />
                                              </>
                                              :
                                              null
                                          }
                                        </>

                                      </>

                                      {/* Remaining Menu */}
                                      <>
                                        {
                                          activeMenus.slice((activeMenus.length - (activeMenus.length % activeTemplate.templateSetting.menu.column)), activeMenus.length).map((menu) => {
                                            return (
                                              <Col span={24 / activeTemplate.templateSetting.menu.column} className='stm-padding-2'>
                                                <Row>
                                                  <Col
                                                    key={menu.id}
                                                    span={24}
                                                    className='stm-background-white-two stm-text-align-center stm-border-radius-4 stm-position-relative stm-padding-top-8 stm-padding-bottom-8'
                                                    onClick={() => this.menuClick(menu.taskID, menu.menuType, menu.isSoon, menu.redirectUrl)}
                                                  >
                                                    {
                                                      menu.isSoon
                                                        ?
                                                        <div className='stm-menu-soon'>{webSettting.soonText}</div>
                                                        :
                                                        null
                                                    }
                                                    <div className=''>
                                                      <img src={menu.imageUrl} alt='iconUrl' className='stm-height-40 stm-width-auto' />
                                                    </div>
                                                    <div
                                                      className='stm-display-flex stm-align-items-center stm-justify-content-center stm-height-40 stm-padding-top-4'
                                                      style={{
                                                        fontFamily: activeTemplate.templateSetting.menu.fontFamily,
                                                        color: activeTemplate.templateSetting.menu.color,
                                                        fontSize: activeTemplate.templateSetting.menu.fontSize,
                                                        lineHeight: `${activeTemplate.templateSetting.menu.fontSize + 2}px`
                                                      }}
                                                    >
                                                      <span>{menu.taskLanguages.find(fi => fi.langID === languageId).taskLangName}</span>
                                                    </div>
                                                  </Col>
                                                </Row>
                                              </Col>
                                            )
                                          })
                                        }
                                      </>
                                    </Row>
                                  </>
                                  :
                                  null
                              }
                            </>

                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </>
                  :
                  null
              }
            </>
            :
            null
        }
      </>
    )
  }
}

export default withTranslation()(Home)